import aloopAxios from "@aloop-util/axios";
let aloop = aloopAxios();
aloop.events({
  onCreate(e) {
    e.domain(process.env.VUE_APP_EXTERNAL_DOMAIN);
  },
});

const searchDomains = function (payload) {
  return aloop.create({
    payload,
    method: "GET",
    path: "read.php?action=SEARCH_DOMAIN",
  });
};

export default {
  parent: aloop,
  searchDomains,
};
